// ============================================================================
// REPOSITORY: CadernoApprovalRepository — Acesso Firestore para aprovações de peças
// ARQUIVO: src/services/CadernoApprovalRepository.js
// ============================================================================

import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export async function sendPieceForApproval(payload, appId = DEFAULT_APP_ID) {
  const col = collection(db, ...FS.portalPieceApprovals(appId));
  await addDoc(col, {
    ...payload,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}
